import React from  'react';
import { Spinner } from "selfly-ui-react";

import './loading.scss';

export default function InnerSpinner(props) {

    const text = typeof props.text === "string" ? props.text : "Loading ...";



    return (
        <div className={`loading loading-inner-spinner ${props.className}`}>
            <Spinner className="inner-spinner" />
            <p>{text}</p>
        </div>
    )
}